export default {"src":"/_next/static/media/hyperjump.e48ce883.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};